import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { UserApi } from '../../api/userApi';
const AdminUsersIsland = () => {
    const [adminData, setAdminData] = useState(null);
    const [usersData, setUsersData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        role: '',
        status: '',
        provider: ''
    });
    const [currentPage, setCurrentPage] = useState(0);
    useEffect(() => {
        // Получаем данные из DOM
        const container = document.getElementById('admin-users-root');
        if (!container) {
            return;
        }
        const page = parseInt(container.dataset.page || '0', 10);
        const size = parseInt(container.dataset.size || '20', 10);
        const total = parseInt(container.dataset.total || '0', 10);
        const role = container.dataset.role || '';
        const status = container.dataset.status || '';
        const provider = container.dataset.provider || '';
        const apiEndpoint = container.dataset.apiEndpoint || '/rest/api/v1/admin/users';
        setAdminData({
            page,
            size,
            total,
            role,
            status,
            provider,
            apiEndpoint
        });
        // Устанавливаем начальные фильтры
        setFilters({
            role,
            status,
            provider
        });
        setCurrentPage(page);
    }, []);
    useEffect(() => {
        if (adminData) {
            loadUsers();
        }
    }, [adminData, filters, currentPage]);
    const loadUsers = async () => {
        if (!adminData)
            return;
        try {
            setLoading(true);
            const userApi = new UserApi();
            const params = {
                page: currentPage,
                size: adminData.size
            };
            if (filters.role)
                params.role = filters.role;
            if (filters.status)
                params.status = filters.status;
            if (filters.provider)
                params.provider = filters.provider;
            const data = await userApi.listAdminUsers(params);
            setUsersData(data);
        }
        catch (error) {
            console.error('Error loading users:', error);
        }
        finally {
            setLoading(false);
        }
    };
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => (Object.assign(Object.assign({}, prev), { [name]: value })));
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setCurrentPage(0);
    };
    const handleResetFilters = () => {
        setFilters({
            role: '',
            status: '',
            provider: ''
        });
        setCurrentPage(0);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const handleAction = async (userId, action) => {
        if (!adminData)
            return;
        try {
            setLoading(true);
            const userApi = new UserApi();
            await userApi.adminAction(userId, action);
            // Перезагружаем данные после действия
            await loadUsers();
        }
        catch (error) {
            console.error(`Error performing action ${action}:`, error);
        }
        finally {
            setLoading(false);
        }
    };
    if (!adminData || !usersData) {
        return null;
    }
    const { role, status, provider, size, total } = adminData;
    const totalPages = Math.ceil(total / size);
    return (_jsxs("div", { children: [_jsxs("h1", { className: "mb-4", children: ["\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 ", _jsx("span", { className: "badge bg-secondary", children: total })] }), _jsxs("form", { onSubmit: handleFilterSubmit, className: "row g-2 mb-3", children: [_jsx("div", { className: "col-auto", children: _jsxs("select", { className: "form-select", name: "role", value: filters.role, onChange: handleFilterChange, children: [_jsx("option", { value: "", children: "\u2014 \u0440\u043E\u043B\u044C \u2014" }), _jsx("option", { value: "USER", children: "USER" }), _jsx("option", { value: "ADMIN", children: "ADMIN" })] }) }), _jsx("div", { className: "col-auto", children: _jsxs("select", { className: "form-select", name: "status", value: filters.status, onChange: handleFilterChange, children: [_jsx("option", { value: "", children: "\u2014 \u0441\u0442\u0430\u0442\u0443\u0441 \u2014" }), _jsx("option", { value: "ACTIVE", children: "ACTIVE" }), _jsx("option", { value: "BLOCKED", children: "BLOCKED" }), _jsx("option", { value: "DELETED", children: "DELETED" })] }) }), _jsx("div", { className: "col-auto", children: _jsx("input", { className: "form-control", name: "provider", placeholder: "\u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 (google\u2026)", value: filters.provider, onChange: handleFilterChange }) }), _jsxs("div", { className: "col-auto", children: [_jsx("button", { className: "btn btn-primary", type: "submit", children: "\u0424\u0438\u043B\u044C\u0442\u0440" }), _jsx("button", { className: "btn btn-outline-secondary", type: "button", onClick: handleResetFilters, children: "\u0421\u0431\u0440\u043E\u0441" })] })] }), _jsx("div", { className: "table-responsive", children: _jsxs("table", { className: "table table-striped align-middle", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C" }), _jsx("th", { children: "\u0420\u043E\u043B\u044C" }), _jsx("th", { children: "\u0421\u0442\u0430\u0442\u0443\u0441" }), _jsx("th", { children: "\u041F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u044B" }), _jsx("th", { children: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0432\u0445\u043E\u0434" }), _jsx("th", { children: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F" })] }) }), _jsx("tbody", { children: usersData.items.map((user) => (_jsxs("tr", { children: [_jsxs("td", { children: [user.avatarUrl && (_jsx("img", { src: user.avatarUrl, alt: "", className: "rounded-circle me-1", width: "24", height: "24", referrerPolicy: "no-referrer" })), _jsx("a", { href: `/u/${user.slug}`, children: user.displayName || '(без имени)' }), user.email && (_jsx("div", { className: "text-muted small", children: user.email }))] }), _jsx("td", { children: _jsx("span", { className: `badge ${user.role === 'ADMIN' ? 'bg-danger' : 'bg-secondary'}`, children: user.role }) }), _jsx("td", { children: _jsx("span", { className: `badge ${user.status === 'ACTIVE' ? 'bg-success' : 'bg-warning text-dark'}`, children: user.status }) }), _jsx("td", { children: user.providers.join(', ') }), _jsx("td", { children: user.lastLoginAt ? new Date(user.lastLoginAt).toLocaleString('ru-RU') : '—' }), _jsxs("td", { children: [user.status === 'ACTIVE' ? (_jsx("button", { className: "btn btn-sm btn-outline-danger", onClick: () => handleAction(user.id, 'block'), disabled: loading, children: "\u0411\u043B\u043E\u043A" })) : (_jsx("button", { className: "btn btn-sm btn-outline-success", onClick: () => handleAction(user.id, 'unblock'), disabled: loading, children: "\u0420\u0430\u0437\u0431\u043B\u043E\u043A" })), user.role !== 'ADMIN' && (_jsx("button", { className: "btn btn-sm btn-outline-primary", onClick: () => handleAction(user.id, 'promote-admin'), disabled: loading, children: "\u0412 \u0430\u0434\u043C\u0438\u043D\u044B" }))] })] }, user.id))) })] }) }), totalPages > 1 && (_jsx("nav", { children: _jsx("ul", { className: "pagination", children: Array.from({ length: totalPages }, (_, i) => (_jsx("li", { className: `page-item ${i === currentPage ? 'active' : ''}`, children: _jsx("button", { className: "page-link", onClick: () => handlePageChange(i), disabled: loading, children: i + 1 }) }, i))) }) }))] }));
};
export default AdminUsersIsland;
